import { Spinner, SpinnerSize } from '@bechtel/gds';
import React, { FC, Suspense } from 'react';
import { ErrorBoundary } from '@bechtel/client-common';
import { CreateSingleBlock } from '../single';
import { CommoditiesSelection } from './commodities-selection';
import { BlocksSubmitted } from './blocks-submitted';
import { CreateMultiBlockProps } from './types';

export const CreateMultiBlock: FC<CreateMultiBlockProps> = ({
  workPackageId,
  commodityTypes,
  commoditiesSelected,
  milestones,
  selectedCommodities,
  submittedBlocks,
  onSetFiles,
  selectedCommodityTypeId,
}) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
        {!commoditiesSelected && (
          <CommoditiesSelection
            workPackageId={workPackageId}
            commodityTypes={commodityTypes}
            selectedCommodityTypeId={selectedCommodityTypeId}
          />
        )}
        {commoditiesSelected && (
          <BlocksSubmitted selectedCommodities={selectedCommodities} submittedBlocks={submittedBlocks} />
        )}
        {commoditiesSelected && <CreateSingleBlock onSetFiles={onSetFiles} milestones={milestones} />}
      </Suspense>
    </ErrorBoundary>
  );
};
